export enum ContactGroupEnum {
        Emergency = 64,
        Billing = 65,
        HolidayProtocol = 66,
        Default = 1086,
        Medical = 5174,
        Account = 5175,
}
